import LoginPageReducer from './reducer';
import LoginPageSelectors from './selector';
import LoginPageSaga from './saga';
import * as LoginPageTypes from './types';
import actions from './actions';

export { LoginPageSelectors, LoginPageSaga, LoginPageTypes, actions };

export default LoginPageReducer;
